import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { SettingsService } from '@app/services/settings.service';
import { BundleType, ImageModel } from 'library-explorer';

@Component({
    selector: 'app-catalog-page-banner',
    templateUrl: './catalog-page-banner.component.html',
    styleUrls: ['./catalog-page-banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CatalogPageBannerComponent implements OnInit {
  public pageSettings: { title: string, image: ImageModel, phoneImage: ImageModel, removeBannerShadow: boolean, removeSearchBar: boolean };

  public searchBundles = [BundleType.CLASS, BundleType.COURSE, BundleType.MODULE, BundleType.LESSON, BundleType.QUIZ];

  constructor(
    private readonly router: Router,
    private readonly settingsService: SettingsService) { }

  ngOnInit(): void {
    this.settingsService.getSettings()
      .subscribe(data => {
        this.pageSettings = data.class;

        this.searchBundles = this.searchBundles.filter(bundle => {
          switch (bundle) {
            case BundleType.CLASS:
              return !data.class.hideClassLevel && data.layout.headerSearchBarBundles?.class
            case BundleType.COURSE:
              return data.layout.headerSearchBarBundles?.course;
            case BundleType.MODULE:
              return !data.system.skip_module && data.layout.headerSearchBarBundles?.module;
            case BundleType.LESSON:
              return data.layout.headerSearchBarBundles?.lesson;
            case BundleType.QUIZ:
              return data.layout.headerSearchBarBundles?.quiz;
          }

          return true;
        });
      });
  }

  public navigateSearchPage(search = ''): void {
    this.router.navigate(['/catalog-search'], { queryParams: { search }});
  }

}
